<template>
    <div>
        <div class="row text-sm" v-if="error">
            <div class="col-12">
                <b-alert variant="danger" :show="!!error" dismissible @dismissed="error = null">
                    {{ error }}
                </b-alert>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-2" >
                <SelectInput 
                    :label="$t('programme')" 
                    :options="programmes" 
                    optionLabel="Name" 
                    v-model="filter.programme"
                    
                    >
                </SelectInput>
            </div>
            <div class="col-xl-2" >
                <SelectInput 
                    :label="$t('year')" 
                    :options="parseYearsForProgramme" 
                    v-model="filter.year" 
                    v-if="mode.default"
                    ></SelectInput>
                <SelectInput 
                    :label="$t('placement-type')" 
                    :options="sessiontypes" 
                    optionLabel="name" 
                    v-model="filter.placement_type" 
                    v-if="mode.hee">
                </SelectInput>
            </div>
            <div class="col-xl-3">
                <SelectInput 
                    :label="$t('group')" 
                    :options="groups" 
                    v-model="filter.group"
                    :valueCb="(option) => { return option; }" 
                    :labelCb="(option) => { return option; }" 
                    v-if="mode.default">
                </SelectInput>
                <SelectInput 
                    :label="$t('placement-provider-name')" 
                    :options="providers" 
                    optionLabel="title"
                    v-model="filter.provider" 
                    v-if="mode.hee">
                </SelectInput>

            </div>
            <div class="col-xl-5">
                <div class="d-flex flex-row align-items-end flex-wrap justify-content-xl-end" style="gap: 1rem" >
                    <DateInput :label="$t('from')" v-model="datetime.from" :min="timetable.datefrom"
                        :max="datetime.to < timetable.dateto ? datetime.to : timetable.dateto" />

                    <DateInput :disabled="!datetime.from" :label="$t('to')" v-model="datetime.to"
                        :min="datetime.from > timetable.datefrom ? datetime.from : timetable.datefrom"
                        :max="timetable.dateto" />
                    <button
                        type="button"
                        class="btn btn-outline-primary mb-3"
                        @click="loadTimetable()"
                    >
                        {{ $t('go') }}<b-icon icon="arrow-right" />
                    </button>    
                </div>
                
            </div>

        </div>

		<div class="text-right mb-3">
			<div class="btn-group" v-if="mode.default">
				<button class="btn btn-on-good"
					:class="{
						'btn-primary': view.all,
						'btn-outline-secondary': !view.all
					}" @click="view.all=true; view.hours =false; view.days=false;"
					>
					{{ $t('all') }}
				</button>
				<button class="btn btn-on-good"
					:class="{
						'btn-primary': view.days,
						'btn-outline-secondary': !view.days
					}" @click="view.all=false; view.hours =false; view.days=true;"
					>
					{{ $t('days') }}
				</button>
				<button class="btn btn-on-good"
					:class="{
						'btn-primary': view.hours,
						'btn-outline-secondary': !view.hours
					}"  @click="view.all=false; view.hours =true; view.days=false;"
					>
					{{ $t('hours') }}
				</button>
			</div>
            <div class="btn-group" v-if="mode.hee && allowtocountsessions">
				<button class="btn btn-on-good"
					:class="{
						'btn-primary': mode.hours,
						'btn-outline-secondary': !mode.hours
					}" @click="mode.hours = true"
					>
					{{ $t('hours') }}
				</button>
				<button class="btn btn-on-good"
					:class="{
						'btn-primary': !mode.hours,
						'btn-outline-secondary': mode.hours
					}"  @click="mode.hours = false;"
					>
					{{ $t('sessions') }}
				</button>
			</div>
			<button class="btn ml-2"
				:class="{
					'btn-outline-secondary': mode.default,
					'btn-primary': mode.hee
				}"
				@click="mode.default=!mode.default; mode.hee=!mode.hee; buildHEE();"
                v-if="!isPlacementProvider()" >
				<b-icon-check-circle v-if="mode.default" /> <b-icon-check-circle-fill v-if="mode.hee" /> {{ $t('hee-format') }}
			</button>
			<button class="btn ml-2"
				:class="{
					'btn-outline-secondary': !view.break,
					'btn-primary': view.break
				}"
				@click="view.break=!view.break;" 
                v-if="!isPlacementProvider()">
				<b-icon-stopwatch v-if="!view.break" /> <b-icon-stopwatch-fill v-if="view.break" /> {{ $t('count-breaks') }}
			</button>

			<button class="btn btn-outline-secondary ml-2" :title="$t('download')" @click="getCSV()">
				<b-icon-download /><!-- if a modal is implemented, make sure to have @click="shownew=true"-->
			</button>
		</div>
        <div v-if="!mode.hours" class="row text-sm">
            <div class="col-12">
                <b-alert variant="primary" show dismissible>
                    <p>{{ $t('sessions-note') }}</p>
                </b-alert>
            </div>
            
        </div>

        <div class="row text-sm" v-if="!error && ((mode.default && loaded && Object.keys(filteredTimetable).length === 0) || (mode.hee && heeLoaded && Object.keys(filteredCourses).length === 0))">
            <div class="col-12">
                <div class="alert alert-info">{{ $t('no-results') }}</div>
            </div>
        </div>

        <div class="sticky-container" v-if="mode.default ? loaded : heeLoaded">
            <table class="table table-sm text-sm table-bordered table-timetable" :class="tableClass" v-if="mode.default">
                <thead>
                    <tr>
                        <th>{{ $t('name') }}</th>
                        <th>{{ $t('programme') }}</th>
                        <th>{{ $t('year') }}</th>
                        <th>{{ $t('group') }}</th>
                        <th>{{ $t('total') }}</th>
                        <th v-for="(sessiontype, i) in sessiontypes" :key="i">
                            {{ sessiontype.name }}
                        </th>
                    </tr>
                    <tr>
                        <th>{{ $t('total') }}</th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th v-for="(sessiontype, i) in sessiontypes" :key="i">
                            <template v-if="view.all || view.days">
                                {{ aggregateSessionDays(sessiontype) !== 0 ? aggregateSessionDays(sessiontype) : null }}{{ view.all && aggregateSessionHours(sessiontype) !==0 ? $t('days-abbr') : null }}
                            </template>
                            <template v-if="view.all || view.hours">
                                {{ aggregateSessionHours(sessiontype) !==0  ? aggregateSessionHours(sessiontype) : null }}{{ view.all && aggregateSessionHours(sessiontype) !==0 ? $t('hours-abbr') : null }}
                            </template>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(student, i) in filteredTimetable" :key="i">
                        <td>{{ student.DisplayName }}</td>
                        <td>{{ $config.getProgrammeNameById(student.programme) }}</td>
                        <td>{{ student.year }}</td>
                        <td>{{ $config.getGroupNameById(student.group) }}</td>
                        <td>
                            {{ view.all || view.days ? student.total_events : null }}{{  view.all ? $t('days-abbr') : null}}
                            {{ view.all || view.hours ? aggregateStudentHours(student) : null }}{{  view.all ? $t('hours-abbr') : null}}
                         </td>
                        <template v-for="sessiontype in sessiontypes">
                            <template v-if="sessiontype.id in student.sessiontypes">
                                <td :key="sessiontype.id"
                                    :class="{ 'td-danger': (student.sessiontypes[sessiontype.id].total_time < modes[sessiontype.id].total_time), 'td-warning': (student.sessiontypes[sessiontype.id].total_time > modes[sessiontype.id].total_time) }">
                                    {{ view.all || view.days ? student.sessiontypes[sessiontype.id].num_events : null}}{{ view.all ? $t('days-abbr') : null}}
                                    {{ view.all || view.hours ? getHours(student.sessiontypes[sessiontype.id]) : null
                                    }}{{  view.all ? $t('hours-abbr') : null}}
                                </td>
                            </template>
                            <template v-else>
                                <td :key="sessiontype.id"
                                    :class="{ 'td-danger': (sessiontype.id in modes && modes[sessiontype.id].total_time > 0) }">
                                </td>
                            </template>
                        </template>
                    </tr>
                </tbody>
            </table>
            <table class="table table-sm text-sm table-bordered table-timetable mt-3" :class="tableClass" v-if="mode.hee">
                <thead>
                    <tr>
                        <th>{{ $t('course-title') }}</th>
                        <th>{{ $t('placement-type') }}</th>
                        <th>{{ $t('placement-provider-name') }}</th>
                        <th>{{ $t('placement-postcode') }}</th>
                        <th>{{ $t('placement-provider-site') }}</th>
                        <th>{{ $t('month') }}</th>
                        <!--th>{{ $t('intake-month') }}</th-->
                        <template v-if="mode.hours">
                        <th  
                            v-for="n in Array.from({ length: 5 }, (_, index) => index + 1)" 
                            :key="n">
                                {{ $t('year-{e}-hours', { e: n }) }}
                        </th>
                        <th>{{ $t('total-hours') }}</th> 
                        </template>
                        <template v-else>
                            <th 
                                v-for="n in Array.from({ length: 5 }, (_, index) => index + 1)" 
                                :key="n">
                                    {{ $t('year-{e}-sessions', { e: n }) }}
                            </th>
                            <th>{{ $t('total-sessions') }}</th>
                        </template>
                        
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(course,key) in filteredCourses" :key="key">
                        <td>{{$config.getProgrammeNameById(course.programme) }}</td>
                        <td>{{ course.ttsessiontype_name }}</td>
                        <td>{{ course.placementprovider_title }}</td>
                        <td>{{ course.ttroom_postcode }}</td>
                        <td>{{ course.ttroom_name }}</td>
                        <td>{{ $t(`month-long-${course.month}`) }}</td>
                        <td v-for="y in Array.from({ length: 5 }, (_, index) => index + 1)" :key="y">
                        {{ getCourseChrono(course[y] ? course[y] : null, mode.hours) }}
                        </td>
                        <td>{{ calculateTotalTime(course, mode.hours) }}</td>
                        
                        
                    </tr>
                </tbody>
            </table>
        </div>
        <template v-else>
            <div>
                <div class="skeleton midnight h20 w100 mr-4 mb-3 float-left" v-for="n in 100" :key="n"></div>
            </div>
        </template>
        <!--MenuModal :show="shownew" @close="shownew = false" :getCSV="getCSV"/-->
    </div>
</template>

<script>
import DateInput from "src/components/Inputs/DateInput";
import Papa from 'papaparse';
//import YesNoToggle from 'src/components/Inputs/YesNoToggle.vue'
//import MenuModal from "src/components/Timetables/DownloadTTModal.vue";


export default {
    components: {
        DateInput,
        //YesNoToggle
        //MenuModal
    },
    data() {
        return {
            loaded: false,
            heeLoaded: false,
            shownew: false,
            sessiontypes: [],
            timetable: [],
            modes: [],
            filter: {},
            programmes: this.$config.getValue('programmes'),
            years: [],
            calcYears: {},
            groups: this.$config.getValue('groups'),
            total_time_per_student: [],
            datetime:{},
            view:{
                days: false,
                hours: false,
                all: true,
                break: true
            },
            mode:{
                default:true,
                hee: false, 
                hours: true
            },
            courses: [],
            providers:[],
            error: null,
            breakdown:{}, 
            user:{
                providers: []
            },
            allowtocountsessions: false
        }
    },
    mounted() {
        this.isPlacementProvider();
        this.loadTimetable();
        this.listProviders();
        
    },
    methods: {
        loadTimetable: function () {
            this.loaded = false;
            this.error = null;
            let datetime ={};
            if(this.datetime.from && this.datetime.to){
                /*
                We make sure that datetime_from begins at the start of the day
                and that datetime_to finishes at the end of it
                */
                datetime.from = `${this.datetime.from} 0:0:0`;
                datetime.to = `${this.datetime.to} 23:59:59`;
            }

            this.$cfetch(`${this.$settings.APIBaseURL}/timetables/events/getstudenttime`, {
                data: {
                    tttimetable_id: this.$route.params["timetableid"]
                    ? Number(this.$route.params["timetableid"]) : null,
                    programme: this.$route.params["programme"],
                    year: this.$route.params["year"],
                    group: this.$route.params["group"],
                    time: ('time' in this.$route.query) ? this.$route.query.time : null,
                    datetime_from: datetime.from,
                    datetime_to: datetime.to
                },
            }).then((res) => {
                if (res.status === "SUCCESS") {
                    this.sessiontypes = res.result.sessiontypes;
                    this.timetable = res.result.timetable;
                    this.total_time_per_student=res.result.total_time_per_student;
                    this.modes = res.result.modes;
                    Object.values(this.timetable).forEach((student)=>{
                        student.total_events = this.addEventsForStudent(student);

                    });
                    
                    
                    this.buildHEE();
                } else {
                    if (res.error_message) {
                        this.error = res.error_message;
                    } else {
                        this.error = this.$t("failed-load-timetable");
                    }
                }
                this.loaded = true;
            });
        },
        groupByYear() { // We group students by year
            if(this.timetable){
                this.years = Object.values(this.timetable).reduce((result, item) => {
                    const year = item.year;
                    if (!result[year]) {
                        result[year] = [];
                    }
                    result[year].push(item);
                    return result;
                }, {});
            }
        },
        buildHEE() {
            this.heeLoaded = false;
            this.error = null;
            this.courses=[];
            let datetime ={};
            if(this.datetime.from && this.datetime.to){
                /*
                We make sure that datetime_from begins at the start of the day
                and that datetime_to finishes at the end of it
                */
                datetime.from = `${this.datetime.from} 0:0:0`;
                datetime.to = `${this.datetime.to} 23:59:59`;
            }


            this.$cfetch(`${this.$settings.APIBaseURL}/timetables/events/getheetime`, {
                data: {
                    tttimetable_id: this.$route.params["timetableid"]
                    ? Number(this.$route.params["timetableid"]) : null,
                    programme: this.$route.params["programme"],
                    year: this.$route.params["year"],
                    group: this.$route.params["group"],
                    time: ('time' in this.$route.query) ? this.$route.query.time : null,
                    datetime_from: datetime.from,
                    datetime_to: datetime.to,
                },
            }).then((res) => {
                if (res.status === "SUCCESS") {

                    this.courses = res.results;
                    this.allowtocountsessions = res.allowtocountsessions;
        

                } else {
                    if (res.error_message) {
                        this.error = res.error_message;
                    } else {
                        this.error = this.$t("failed-load-timetable");
                    }
                }
                this.heeLoaded = true;
            });
        },

        handleRegularTT(timetable){

            let calculatedTimetable = {};
            let sessions = {};
            let formattedTimetable=[];

            calculatedTimetable = Object.keys(timetable).map(user => {
                for (let id in this.sessiontypes){ // Define and hydrate sessioncols
                    sessions[this.sessiontypes[id].name]=null;
                }

                // The next comment is because we want to drop the some attributes from filteredTimetable

                // eslint-disable-next-line no-unused-vars
                let { sessiontypes, selected, placementprovider_title,  ...rest } = timetable[user];
                    for (let key in this.sessiontypes) {
                        for(let session_id in sessiontypes){// We loop through this.sessiontypes and sessiontypes
                            if (this.sessiontypes[key].id === session_id) {
                                //If there is a match, then we add the sessiontype total_time, num_events or both to sessions

                                sessions[this.sessiontypes[key].name]=
                                    this.view.all ?
                                    `${Math.round(sessiontypes[this.sessiontypes[key].id].total_time/3600)}h ${sessiontypes[this.sessiontypes[key].id].num_events}d` :
                                    this.view.days ?  sessiontypes[this.sessiontypes[key].id].num_events : Math.round(sessiontypes[this.sessiontypes[key].id].total_time/3600)
                            }
                        }
                    }

				return { ...rest,
					'total': this.view.all ?
					`${this.aggregateStudentHours(timetable[user])}h ${timetable[user].total_events}d` :
					this.view.days ?  timetable[user].total_events : this.aggregateStudentHours(timetable[user])  ,
					...sessions
				};
            });

            //Format keys for CSV
            let csvCols = {
                "user_id": "User ID",
                "DisplayName": "Display Name",
                "programme": "Programme",
                "year" : "Year",
                "group" : "Group",
                "total": "Total"
            }

            formattedTimetable = Object.keys(calculatedTimetable).map((key) => {
                const user = calculatedTimetable[key];
                const formattedUser ={}

                for (const prop in user) {// rename key if needed
                    formattedUser[csvCols[prop] || prop] = user[prop];
                }

                return formattedUser;
            });

            // Create totals row, set to null the cols that are not sessions
            let totals={
                "User ID": 'Total',
                "Display Name": null,
                "Programme": null,
                "Year" : null,
                "Group" : null,
                "Total":null
            }

            for (let key in this.sessiontypes){ // Populate and hydrate totals
                const session = this.sessiontypes[key];
                if(this.aggregateSessionHours(session) || this.aggregateSessionDays(session)){
                    totals[session.name]=this.view.all ? `${this.aggregateSessionHours(session)}${this.$t('hours-abbr')} ${this.aggregateSessionDays(session)}${this.$t('days-abbr')}` :
                        this.view.days ?  this.aggregateSessionDays(session) : this.aggregateSessionHours(session);
                } else {
                    totals[this.sessiontypes[key].name]=null;
                }
            }

            // Add totals at the top
            formattedTimetable.splice(0,0,totals);

            //Get the final timetable
            return formattedTimetable;

        },
        handleHEETT(hours){
            let timetable = this.courses;

            //Format keys for CSV
            let csvCols = {};

            if(hours){
                csvCols = {
                    "1": "Year 1 Hours",
                    "2": "Year 2 Hours",
                    "3": "Year 3 Hours",
                    "4": "Year 4 Hours",
                    "5": "Year 5 Hours"
                }
            } else {
                csvCols = {
                    "1": "Year 1 Sessions",
                    "2": "Year 2 Sessions",
                    "3": "Year 3 Sessions",
                    "4": "Year 4 Sessions",
                    "5": "Year 5 Sessions"
                }
            }
             

            let formattedTimetable=[];
            formattedTimetable = Object.keys(timetable).map((key) => {
                const course = timetable[key];

                const formattedCourse = {
                	"Course Title": this.$config.getProgrammeNameById(course.programme),
                    "Placement Type": course.ttsessiontype_name,
                    "Placement Provider Name": course.placementprovider_title,
                    "Placement Postcode": course.ttroom_postcode,
					"Placement Provider Site": course.ttroom_name,
					"Month": this.$t(`month-long-${course.month}`)
                }

         
                for (let year = 1; year <= 5; year++) {// rename key if needed
                    formattedCourse[csvCols[year]] = this.getCourseChrono(course[year], this.mode.hours);
                }

                formattedCourse[hours ? "Total Hours" : "Total Sessions"] = this.calculateTotalTime(course, this.mode.hours);
                
                
                
                return formattedCourse;
            });

            return formattedTimetable;
        },
        getCSV() {
            let timetable =[]
            if(this.mode.default){
                timetable = this.handleRegularTT(this.filteredTimetable);
            }

            if(this.mode.hee){
                timetable=this.handleHEETT(this.mode.hours)
            }

            // Get the CSV via a Promise
            return new Promise((resolve, reject) => {
                try {
                    const csv = Papa.unparse(timetable);
                    resolve(csv);
                } catch (error) {
                    console.error('Error unparsing CSV file:', error);
                    reject(error);
                }
            }).then(res => {
                // Create a Blob from the CSV string
                const blob = new Blob([res], { type: 'text/csv' });

                // Give it a download link
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'data.csv';

                // Trigger download
                a.click();

                // Housekeeping
                URL.revokeObjectURL(url);
            });
        },
        addEventsForStudent(student){
            let sum = 0;

            for (const sessionId in student.sessiontypes) {
                sum += parseInt(student.sessiontypes[sessionId].num_events);
            }

            return sum;
        },
       listProviders(){
            return this.$cfetch(`${this.$settings.APIBaseURL}/placementprovider/list`,{
                method: "post",
                data:{
                }
            })
            .then((res) => {
				if (res.status === "SUCCESS") {
                    this.providers=res.results;
				} else {
					this.$log.info.call(this, status)
				}
			}).catch(error => {
				this.$log.error.call(this, error);
			});
        },
        getUserProviders(){
            this.providers.find(provider => {
                if (provider.user.length > 0) {
                    if(provider.user.some(user => user.id == this.$UserSession.getValue.call(this, 'id'))){
                        this.user.providers.push(provider.id);
                    }
                    return provider.user.some(user => user.id == this.$UserSession.getValue.call(this, 'id'));
                }
                return false;
            });
        },
        isPlacementProvider(){
            if(this.$UserSession.hasPriv.call(this,'PLACEMENT_MY_PLACEMENTS')
            && !this.$UserSession.hasPriv.call(this,'ALL') ){
                this.mode.hee = true;
                this.mode.default = false;
                return true;
            }
            return false;
        },
        getCourseChrono(courseYear, hours){
            if(!courseYear) return 0;
            if(hours){
                if(this.view.break && courseYear.break_time){
                    return Math.round((courseYear.total_time - courseYear.break_time) / 36)/100;
                }
                return Math.round(courseYear.total_time / 36)/100; // f[(x/3600)*100]/100=f[x/36]/100
            } else {
                return courseYear.days;
            }
            
            
        },
        calculateTotalTime(course, hours){
                let total=0;

                for (let year = 1; year <= 5; year++){
                	if(course[year]){
                    	total += this.getCourseChrono(course[year],hours);
                    }
                }

                return total !==0 ? total  : 0 ;

        },

    },
    computed: {
        tableClass: function () {
            if (Object.keys(this.timetable).length > 25) {
                return 'table-timetable-sm'
            }
            return '';
        },
        parseYearsForProgramme() {
            let programme = {};
            if (this.filter.programme) {
                programme = this.filter.programme;
            }

            let arr_years = []

            for (var i = 1; i <= programme["CourseLengthYears"]; i++) {
                arr_years.push(i);
            }

            return arr_years;
        },
        filteredTimetable() {
            let filteredTimetable = {};

            if (Object.keys(this.filter).length === 0
                || Object.values(this.filter).every(value => value === null)) {
                // If there are no filters, the default timetable is passed
                filteredTimetable = this.timetable;
            } else {
                for (var key in this.timetable) {
                    var obj = this.timetable[key];

                    if (obj && typeof obj === 'object' && 'programme' in obj) {
                        if (//this.filter.programme &&
                             obj.programme === this.filter.programme['Id']
                            && (!this.filter.year || obj.year == this.filter.year)
                            && (!this.filter.group || obj.group == (Number(this.filter.group) + 6))) {

                            /* First we check for a programme, and then a year or group.
                            This is a quick fix because $config.getValue('groups')
                            returns { "7": "1", "8": "2", "9": "3", "10": "4", "11": "5", "12": "6" }*/
                            filteredTimetable[key] = obj;
                        }
                    }
                }
            }
            return filteredTimetable;
        },
        filteredCourses() {
            let filteredCourses = {};

            if (Object.keys(this.filter).length === 0
                || Object.values(this.filter).every(value => value === null)) {
                // If there are no filters, the default courses are passed
                filteredCourses = this.courses;
            } else {
                for (var key in this.courses) {
                    var obj = this.courses[key];

                    if (obj && typeof obj === 'object' && 'programme' in obj) {
                        if (
                            (!this.filter.programme || obj.programme === this.filter.programme['Id'])
                            && (!this.filter.placement_type || obj.session_id == this.filter.placement_type.id)
                            && (!this.filter.provider || obj.placementprovider_id == this.filter.provider.id)) {

                            filteredCourses[key] = obj;
                        }
                    }
                }
            }
            return filteredCourses;
        },
        getHours(){
            return (sessiontype) =>{
                if(this.view.break && sessiontype.break_time){
                    return Math.round((sessiontype.total_time - sessiontype.break_time*sessiontype.num_events) / 36)/100;
                }
                return Math.round(sessiontype.total_time / 36)/100; // f[(x/3600)*100]/100=f[x/36]/100
            }

        },
        /*getCourseChrono(){
            return (courseYear) => {
                if(!courseYear) return 0;
                if(this.view.break && courseYear.break_time){
                    return Math.round((courseYear.total_time - courseYear.break_time) / 36)/100;
                }
                return Math.round(courseYear.total_time / 36)/100; // f[(x/3600)*100]/100=f[x/36]/100
            }
        },*/
        aggregateStudentHours(){
            return (student) => {
                let sum = 0;
                for(let session in student.sessiontypes){
                    sum += this.getHours(student.sessiontypes[session])
                }
                return sum;
            }
        },
        aggregateSessionHours(){
            return (session) => {
                let sum = 0;

                for (let key in this.filteredTimetable){
                    const student = this.filteredTimetable[key];
                    if(session.id in student.sessiontypes){
                        sum += this.getHours(student.sessiontypes[session.id])
                    }

                }
                return sum;
            }
        },
        aggregateSessionDays(){
            return (session) => {
                let sum = 0;

                for (let key in this.filteredTimetable){
                    const student = this.filteredTimetable[key];
                    if(session.id in student.sessiontypes){
                        sum += student.sessiontypes[session.id].num_events;
                    }

                }
                return sum;
            }
        },
        /*calculateTotalTime(){
            return (course) => {
                let total=0;

                for (let year = 1; year <= 5; year++){
                	if(course[year]){
                    	total += this.getCourseChrono(course[year]);
                    }
                }

                return total !==0 ? total  : 0 ;
            }

        },*/
    }
};
</script>
